import { render, staticRenderFns } from "./TaskTemplate.vue?vue&type=template&id=384a804d"
import script from "./TaskTemplate.vue?vue&type=script&lang=js"
export * from "./TaskTemplate.vue?vue&type=script&lang=js"
import style0 from "./TaskTemplate.vue?vue&type=style&index=0&id=384a804d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports